import React from 'react';
import { HelmetTitle } from '@games/ui';
import { useIntl } from 'react-intl';
import messages from 'intl/messages';
import PuzzleQuery, { PuzzleQueryProps } from './PuzzleQuery';
import MyAd from './MyAd';
import { HowToSolve } from './HowToSolve';
import { TipsAndTricks } from './TipsAndTricks';

interface DefaultPageProps {
  match: {
    params: {
      size?: string;
      puzzleId?: string;
      date?: string;
    };
  };
}

const DefaultPage: React.FC<DefaultPageProps> = ({ match }) => {
  const { formatMessage } = useIntl();

  let p: PuzzleQueryProps = {};
  if (typeof match.params.size !== 'undefined') {
    p = {
      size: parseInt(match.params.size, 10),
    };
  } else if (typeof match.params.puzzleId !== 'undefined') {
    p = {
      id: parseInt(match.params.puzzleId, 10),
    };
  } else if (typeof match.params.date !== 'undefined') {
    p = {
      isDaily: true,
      date: match.params.date,
    };
  } else if (window.location.pathname.endsWith('/daily')) {
    p = {
      isDaily: true,
    };
  }
  console.log('p:', p);
  return (
    <div className='text-center'>
      <HelmetTitle message={formatMessage(messages.nonogramPuzzle)} />
      <div>
        <MyAd
          slot='6326482591'
          className='w-full min-h-[467px] md:min-h-[280px]'
        />
      </div>
      <div className='flex flex-col lg:flex-row'>
        <div className='hidden lg:block w-1/6'>
          {' '}
        </div>
        <div className='w-full lg:w-2/3'>
          <PuzzleQuery {...p} />
        </div>
        <div className='w-full lg:w-1/6'>
          <MyAd slot='1756682195'  />
        </div>
      </div>
      <HowToSolve />
      <TipsAndTricks />
    </div>
  );
};

export default DefaultPage;
